// 課金API（#35 で実装した /api/billing/*）の呼び出し（Issue #36）。
//
// **金額をこのファイルに書かない。** 価格はサーバの価格表（modules/billing/pricing.py）が正で、
// 画面は fetchPlans() が返した値だけを表示する。
import apiClient from './client';

// 課金機能が無効（BILLING_ENABLED=false）のとき、これらのルートはそもそも登録されていない。
// 呼び出し側が「準備中」を出せるように 404 だけ区別する。
export class BillingUnavailableError extends Error {
  constructor() {
    super('ただいま準備中です。');
    this.name = 'BillingUnavailableError';
  }
}

const toError = (error) => {
  const status = error?.response?.status;
  if (status === 404) return new BillingUnavailableError();
  const detail = error?.response?.data?.detail;
  const failure = new Error(detail || '通信に失敗しました。時間をおいて再度お試しください。');
  failure.status = status;
  return failure;
};

export const fetchPlans = async () => {
  try {
    const response = await apiClient.get('/api/billing/plans');
    return response.data;
  } catch (error) {
    throw toError(error);
  }
};

export const fetchSubscription = async () => {
  try {
    const response = await apiClient.get('/api/billing/subscription');
    return response.data;
  } catch (error) {
    throw toError(error);
  }
};

export const startCheckout = async ({ transactionTokenId, contents }) => {
  try {
    const response = await apiClient.post('/api/billing/checkout', {
      transaction_token_id: transactionTokenId,
      contents,
    });
    return response.data;
  } catch (error) {
    throw toError(error);
  }
};

export const cancelSubscription = async () => {
  try {
    const response = await apiClient.post('/api/billing/subscription/cancel');
    return response.data;
  } catch (error) {
    throw toError(error);
  }
};
